import Modal from "../../../Framework/Components/Modals/Modal";
import {ModalType} from "../../../Framework/Types/ModalTypes";
import SendsHistoryControl from "../Controls/SendsHistoryControl";
import React, {useRef} from "react";
import {ModalSize} from "../../../Framework/Data/Enums/Generic";

interface PageHistoryModalType extends ModalType {
    pageId: number;
}

const PageHistoryModal = (props: PageHistoryModalType) => {
    const sendsHistoryRef = useRef<any>();

    return (
        <Modal title={'Page History'} isOpen={props.visible} closeCallback={() => props.closeCallback()} modalSize={ModalSize.Large}>
            <SendsHistoryControl containerRef={sendsHistoryRef} hideHeader={true} />
        </Modal>
    )
}

export default PageHistoryModal